"use strict";
/**
 * @file Created on Fri Nov 09 2018
 * @author Tomáš Leity
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Validator that checkes date in range
 *
 * @param min - minimal date in range
 * @param max - maximal date in range
 */


var DateRangeValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(DateRangeValidator, _Validator_1$Validato);

  function DateRangeValidator(min, max, callback) {
    var _this;

    var dateFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DD/MM/YYYY';

    _classCallCheck(this, DateRangeValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRangeValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.min = min;
    _this.max = max;
    _this.callback = callback;
    _this.dateFormat = dateFormat;
    return _this;
  }

  _createClass(DateRangeValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (!moment.isMoment(value)) {
        return new ValidationResult_1.ValidationError(DateRangeValidator.BAD_DATE_INPUT_TYPE_ERROR);
      }

      if (moment.isMoment(this.min) && moment.isMoment(this.max)) {
        if (this.callback) {
          return this.callback(value, this.min, this.max, DateRangeValidator.DATE_OUT_OF_RANGE_ERROR);
        }

        if (this.min && this.max && (this.min > value || value > this.max)) {
          return new ValidationResult_1.ValidationError(DateRangeValidator.DATE_OUT_OF_RANGE_ERROR, "".concat(this.min.format(this.dateFormat), " - ").concat(this.max.format(this.dateFormat)));
        }
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return DateRangeValidator;
}(Validator_1.Validator);

exports.DateRangeValidator = DateRangeValidator;
DateRangeValidator.BAD_DATE_INPUT_TYPE_ERROR = 'BAD_DATE_INPUT_TYPE';
DateRangeValidator.DATE_OUT_OF_RANGE_ERROR = 'DATE_OUT_OF_RANGE';